import styled from 'styled-components/native'
import { Text } from 'react-native-elements'

const NoWrapText = styled(Text)`
  white-space: nowrap;
`
export default NoWrapText
